// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Pages/Collections/Collections.css
// module id = 210
// module chunks = 0